import { Link } from 'gatsby';
import Img from 'gatsby-image';
import _ from 'lodash';
import React from 'react';
import { PageContext } from '../../templates/blog/post';

export interface PostCardProps {
  post: PageContext;
  large?: boolean;
}

export const BookCard: React.FC<PostCardProps> = ({ post, large = false }) => {
  return (
    <>

      <div className="col-sm-6 col-md-4 col-lg-3">
        <div className="iq-card iq-card-block iq-card-stretch iq-card-height browse-bookcontent">
          <div className="iq-card-body p-0">
            <div className="d-flex align-items-center">
              <div className="img-wrapper col-5 p-0 position-relative image-overlap-shadow">


                {post.frontmatter.image && (
                  <Link
                    to={`/books-summary${post.fields.slug}`}>
                    {post.frontmatter?.image?.childImageSharp?.fluid && (
                      <Img
                        alt={`${post.frontmatter.title} cover image`}
                        style={{ height: '100%' }}
                        fluid={post.frontmatter.image.childImageSharp.fluid}
                      className="zoom-on-hover"
                      />
                    )}
                  </Link>
                )}

                <div data-sal="slide-up" className="view-book">
                  <Link to={`/books-summary${post.fields.slug}`} className="btn btn-sm premium-btn-black">Read Now</Link>
                </div>
              </div>
              <div className="col-7">

                <div>
                  {/* BOOK TAGS DISABLE */}

                  {/* {post.frontmatter.tags && (
                    <Link to={`/book-categories/${_.kebabCase(post.frontmatter.tags[0])}/`}>
                      {post.frontmatter.tags[0]}
                    </Link>
                  )} */}
                  <Link
                    to={`/books-summary${post.fields.slug}`}>  
                    <h2 style={{ fontSize: "1.8rem", color: 'black' }} className="mb-4">
                      {post.frontmatter.title}
                    </h2>
                  </Link>

                </div>
                <div data-sal="slide-up"className="price d-flex align-items-center">
                  <b> {post.fields.readingTime.text}</b>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

